export const DELIMITER = '/'; // currently no support for other cultures e.g. German date format is 15.01.1999

type DateSegmentType = 'day' | 'month' | 'year';

export class DateSegment {
  private digits: number[] = [];

  private canAddDigit = true;

  private placeholders: Record<DateSegmentType, string> = {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
  };

  static day = (initialValue?: number): DateSegment => new DateSegment('day', initialValue);

  static month = (initialValue?: number): DateSegment => new DateSegment('month', initialValue);

  static year = (initialValue?: number): DateSegment => new DateSegment('year', initialValue);

  static defaultDateSegments = () => [DateSegment.day(), DateSegment.month(), DateSegment.year()];

  private constructor(
    private type: DateSegmentType,
    initialValue?: number
  ) {
    if (initialValue !== undefined && initialValue > 0) {
      if (type === 'year') {
        this.digits = [...initialValue.toString()].map(Number);
      } else {
        const max = type === 'day' ? 31 : 12;
        const limitedValue = Math.min(max, initialValue);
        this.digits = limitedValue < 10 ? [0, limitedValue] : [Math.floor(limitedValue / 10), limitedValue % 10];
      }
    }
  }

  isEmpty = () => this.digits.length === 0;

  isComplete = () => !this.canAddDigit && this.digits.length === 2;

  print = () => (this.isEmpty() ? this.placeholders[this.type] : this.digits.join(''));

  value = (): number | undefined => (this.isEmpty() ? undefined : Number(this.digits.join('')));

  private addDayOrMonthDigitHelper = (digit: number, limit: number) => {
    if (this.isEmpty() || this.isComplete()) {
      this.canAddDigit = digit < limit / 10;
      this.digits = [0, digit];
    } else {
      const firstDigit = this.digits[1];
      const result = firstDigit * 10 + digit;
      if (result < limit) {
        this.digits = [firstDigit, digit];
        this.canAddDigit = false;
      }
    }
  };

  removeDigit = () => {
    this.digits = [];
    this.canAddDigit = true;
  };

  addDigit = (digit: number) => {
    if (this.type === 'day') {
      this.addDayOrMonthDigitHelper(digit, 32);
    } else if (this.type === 'month') {
      this.addDayOrMonthDigitHelper(digit, 13);
    } else {
      if (this.isEmpty()) {
        this.digits = [0, 0, 0, 0];
      }
      this.digits.shift();
      this.digits.push(digit);
    }
  };
}
